import { applyDefaultDate as D } from "./date-utils.mjs";
const b = ({
  props: s,
  value: t,
  adapter: e
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: i,
    shouldDisableMonth: l,
    shouldDisableYear: n,
    disablePast: r,
    disableFuture: c,
    timezone: m
  } = s, a = e.utils.dateWithTimezone(void 0, m), o = D(e.utils, s.minDate, e.defaultDates.minDate), u = D(e.utils, s.maxDate, e.defaultDates.maxDate);
  switch (!0) {
    case !e.utils.isValid(t):
      return "invalidDate";
    case !!(i && i(t)):
      return "shouldDisableDate";
    case !!(l && l(t)):
      return "shouldDisableMonth";
    case !!(n && n(t)):
      return "shouldDisableYear";
    case !!(c && e.utils.isAfterDay(t, a)):
      return "disableFuture";
    case !!(r && e.utils.isBeforeDay(t, a)):
      return "disablePast";
    case !!(o && e.utils.isBeforeDay(t, o)):
      return "minDate";
    case !!(u && e.utils.isAfterDay(t, u)):
      return "maxDate";
    default:
      return null;
  }
};
export {
  b as validateDate
};
//# sourceMappingURL=validateDate.mjs.map
